import router from '@/router';

export default function(continueUrl: string) {
	if (continueUrl.substr(0, 4) === 'http') {
		window.location.href = continueUrl;
	} else {
		router.push(continueUrl);
	}
}
